export default {
  // Page titles
  'pages.log.rawIngestion.title': 'Upload Payloads',
  'pages.log.rawIngestion.subtitle':
    'Raw arrival records of client uplink data (captured on receipt, including malformed/rejected payloads); view raw payloads, download originals, and replay them into the sync pipeline',

  // Table columns
  'pages.log.rawIngestion.column.receivedAt': 'Received At',
  'pages.log.rawIngestion.column.receivedAtRange': 'Received At Range',
  'pages.log.rawIngestion.column.batchNo': 'Batch No.',
  'pages.log.rawIngestion.column.batchNo.placeholder': 'Exact match',
  'pages.log.rawIngestion.column.batchNo.copy': 'Copy batch No.',
  'pages.log.rawIngestion.column.batchNo.copied': 'Copied',
  'pages.log.rawIngestion.column.endpoint': 'Endpoint',
  'pages.log.rawIngestion.column.tenant': 'Tenant',
  'pages.log.rawIngestion.column.store': 'Store',
  'pages.log.rawIngestion.column.tenant.placeholder':
    'Select a tenant (searchable)',
  'pages.log.rawIngestion.column.store.placeholder':
    'Select a store (searchable)',
  'pages.log.rawIngestion.column.store.placeholderFirst':
    'Select a tenant first',
  'pages.log.rawIngestion.column.device': 'Device',
  'pages.log.rawIngestion.column.device.copy': 'Copy Device ID',
  'pages.log.rawIngestion.column.device.copied': 'Copied',
  'pages.log.rawIngestion.column.size': 'Payload Size',
  'pages.log.rawIngestion.column.parseStatus': 'Status',
  'pages.log.rawIngestion.column.rejectReason': 'Reject Reason',
  'pages.log.rawIngestion.column.action': 'Actions',

  // Common placeholders / hints
  'pages.log.rawIngestion.placeholder.select': 'Select an option',
  'pages.log.rawIngestion.tooltip.nameNotBackfilled': 'name not backfilled',

  // Endpoint options
  'pages.log.rawIngestion.endpoint.orderBatch': 'Order Batch',
  'pages.log.rawIngestion.endpoint.operationalBatch': 'Operational Batch',
  'pages.log.rawIngestion.endpoint.memberLogs': 'Member Logs',
  'pages.log.rawIngestion.endpoint.mallUpload': 'Mall Upload',

  // Parse status options (English aligned with backend enumPick)
  'pages.log.rawIngestion.parseStatus.captured': 'Captured',
  'pages.log.rawIngestion.parseStatus.accepted': 'Accepted',
  'pages.log.rawIngestion.parseStatus.rejected': 'Rejected',
  'pages.log.rawIngestion.parseStatus.error': 'Error',

  // Actions
  'pages.log.rawIngestion.action.detail': 'Detail',
  'pages.log.rawIngestion.action.reload': 'Reload',
  'pages.log.rawIngestion.action.reload.confirmTitle': 'Confirm Reload',
  'pages.log.rawIngestion.action.reload.confirmDesc':
    'This will take the original payload and replay it into the sync pipeline as-is (only order/operational batches are supported). Continue?',
  'pages.log.rawIngestion.action.reload.tip':
    'Replay into the sync pipeline (idempotent by batch No.)',
  'pages.log.rawIngestion.action.reload.unsupported':
    'Reload is not supported for this endpoint',

  // Messages
  'pages.log.rawIngestion.msg.loadDetailFailed': 'Failed to load detail',
  'pages.log.rawIngestion.msg.reloadSuccess':
    'Reload succeeded (new arrival {id})',
  'pages.log.rawIngestion.msg.replayResponse':
    'Replay response: code={code} {msg}',
  'pages.log.rawIngestion.msg.unknownId': 'unknown',

  // Detail drawer
  'pages.log.rawIngestion.drawer.title': 'Arrival Detail',
  'pages.log.rawIngestion.drawer.download': 'Download Original',
  'pages.log.rawIngestion.drawer.loading': 'Loading…',
  'pages.log.rawIngestion.detail.arrivalId': 'Arrival ID',
  'pages.log.rawIngestion.detail.receivedAt': 'Received At',
  'pages.log.rawIngestion.detail.endpoint': 'Endpoint',
  'pages.log.rawIngestion.detail.tenant': 'Tenant',
  'pages.log.rawIngestion.detail.store': 'Store',
  'pages.log.rawIngestion.detail.posId': 'Device ID',
  'pages.log.rawIngestion.detail.clientIp': 'Client IP',
  'pages.log.rawIngestion.detail.bodySize': 'Payload Bytes',
  'pages.log.rawIngestion.detail.parseStatus': 'Status',
  'pages.log.rawIngestion.detail.sinkFile': 'File Location',
  'pages.log.rawIngestion.detail.rejectReason': 'Reject Reason',
  'pages.log.rawIngestion.detail.rawBody': 'Raw Payload',
  'pages.log.rawIngestion.detail.copyTruncated':
    'Copy preview (truncated; download for full text)',
  'pages.log.rawIngestion.detail.copyOriginal': 'Copy original payload',
  'pages.log.rawIngestion.detail.copied': 'Copied',
  'pages.log.rawIngestion.detail.truncatedTag':
    'Truncated at 64KB; download for full text',
  'pages.log.rawIngestion.detail.binaryTag': 'Binary payload; download to view',
  'pages.log.rawIngestion.detail.noPreviewBinary':
    'Binary payload has no text preview',
  'pages.log.rawIngestion.detail.noPreview':
    'No previewable payload (metadata-only row or archived file)',
};
